"use strict";
/**
 * This file contains our type guards.
 *
 * Type guards are a feature of TypeScript which narrow the type signature of
 * intesection types (types that can be one thing or another).
 *
 * @see
 * https://www.typescriptlang.org/docs/handbook/advanced-types.html#type-guards-and-differentiating-types
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFaceErrorCode = exports.isJsonRpcErrorCode = exports.isEmpty = exports.isJsonRpcResponsePayload = exports.isJsonRpcRequestPayload = void 0;
const error_1 = require("../error");
const json_rpc_1 = require("../json-rpc");
/**
 * Assert `value` is `undefined`.
 */
function isUndefined(value) {
    return typeof value === 'undefined';
}
/**
 * Assert `value` is `null`.
 */
function isNull(value) {
    return value === null;
}
/**
 * Assert `value` is `null` or `undefined`.
 */
function isNil(value) {
    return isNull(value) || isUndefined(value);
}
/**
 * Assert `value` is a `JsonRpcRequestPayload` object.
 */
function isJsonRpcRequestPayload(value) {
    if (isNil(value))
        return false;
    return (!isUndefined(value.jsonrpc) &&
        !isUndefined(value.id) &&
        !isUndefined(value.method) &&
        !isUndefined(value.params));
}
exports.isJsonRpcRequestPayload = isJsonRpcRequestPayload;
/**
 * Assert `value` is a `JsonRpcResponsePayload` object.
 */
function isJsonRpcResponsePayload(value) {
    if (isNil(value))
        return false;
    return (!isUndefined(value.jsonrpc) &&
        !isUndefined(value.id) &&
        (!isUndefined(value.result) || !isUndefined(value.error)));
}
exports.isJsonRpcResponsePayload = isJsonRpcResponsePayload;
/**
 * Assert `value` is an empty, plain object.
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function isEmpty(value) {
    if (!value)
        return true;
    for (const key in value) {
        /* istanbul ignore else */
        if (Object.hasOwnProperty.call(value, key)) {
            return false;
        }
    }
    return true;
}
exports.isEmpty = isEmpty;
/**
 * Assert `value` is an expected JSON RPC error code.
 */
function isJsonRpcErrorCode(value) {
    if (isNil(value))
        return false;
    return typeof value === 'number' && Object.values(json_rpc_1.RpcErrorCode).includes(value);
}
exports.isJsonRpcErrorCode = isJsonRpcErrorCode;
/**
 * Assert `value` is an expected JSON RPC error code.
 */
function isFaceErrorCode(value) {
    if (isNil(value))
        return false;
    return typeof value === 'number' && Object.values(error_1.FaceErrorCode).includes(value);
}
exports.isFaceErrorCode = isFaceErrorCode;
//# sourceMappingURL=typeGuards.js.map